import { Environment } from '@rcsa/rcsa-frontend-shared';

export const environment: Environment = {
  allowedConceptsMSI: [
    {
      IN: 'ee73edaf-45d2-516a-adb3-b4efeb8b66fa'
    },
    {
      RI: '967a7d9c-0d62-5a39-a139-12fc95b43a52'
    }
  ],
  apiUrl: 'https://pagos-api.semperaltius.edu.mx',
  chat: {
    adminUrl: 'https://static.zdassets.com/ekr/snippet.js?key=b31b1a77-9185-4bd4-83d8-3b5fc55a00cc',
    userUrl: 'https://static.zdassets.com/ekr/snippet.js?key=ade669ef-43fc-4d45-aac9-d31b0da28930'
  },
  enable3DS: false,
  enabledSwitcherApplication: true,
  featureFlagsEnabled: true,
  isSyncfyProd: true,
  isTestEnvironment: false,
  maxReferenceAmount: 20000,
  merchantId: '48322226451a42249bebd45bd1a4dc1d',
  portalUrl: 'https://pagos.semperaltius.edu.mx',
  production: true,
  productionPortalUrl: 'https://pagos.semperaltius.edu.mx/',
  reporterUrl: 'https://pagos-reportes.semperaltius.edu.mx',
  sentry: {
    environment: 'production'
  },
  support: {
    adminParam: '&return_to=https%3A%2F%2Fsoporte-pagos-admin.semperaltius.edu.mx%2Fhc%2Fes-419&role=consumer&theme=hc',
    ssoUrl: 'https://rcsasupport.zendesk.com/access/jwt?jwt=',
    ticketsUrl: 'https://rcsasupport.zendesk.com/agent/tickets',
    userParam: '&return_to=https%3A%2F%2Fsoporte-pagos.semperaltius.edu.mx%2Fhc%2Fes-419&role=consumer&theme=hc'
  },
  tokenizerEnvironment: 'production',
  tokenizerRouteId: 'CEC53LqGac',
  uriHubPlusReporter: 'https://pagos-reportes.semperaltius.edu.mx/login/',
  versionUrl: 'app-version.json',
  travel: {
    url: 'https://tdla-front.marketsync.mx',
    active: true
  }
};
